import { render, staticRenderFns } from "./GamePlayer.vue?vue&type=template&id=6bd18281"
import script from "./GamePlayer.vue?vue&type=script&lang=js"
export * from "./GamePlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports